export { TabSlider } from './tab-slider';
